export default __webpack_public_path__ + "files/thumbnail-b33e708961fd2fecbe42dae91bcb1e57.png";